import axios from "axios";
import { Message } from 'element-ui';
import router from "@/router";

export function initLoginUser () {
    return axios({
        method:'GET',
        url:'/system-ya/user/default/login',
    })
}

export function initPermissions(){
    return axios({
        method:'GET',
        url:'/system-ya/user/default/per',
    })
}

export function initSocket(){
    return axios({
        method:'GET',
        url:'/system-ya/messages/support/site/connect',
    })
}

export function showBigReportINDEX(){
    return axios({
        method:'GET',
        url:'/system-ya/projectProject/selectUrl',
    })
}

export function UserMessage(id){
    return axios({
        method:'GET',
        url:'/system-ya/messages/unreadCount/'+id,
    })
}

export function getOneBYAgedINDEX(id){
    return axios({
        method:'GET',
        url:'/system-ya/aged/selectOneByAged/'+id,
    })
}

export function EdbInfo(){
    return axios({
        method:'POST',
        url:'/system-ya/edb/status',
    })
}

export function getUserPlatfromName(){
    return axios({
        method:'GET',
        url:'/system-ya/user/platfrom',
    })
}

export function initMenuDatanew(){
    return axios({
        method:'POST',
        url: "/system-ya/menu/treeByUser",
        async: false,
        contentType: 'application/json;charset=UTF-8',
    })
}

export function gethandleSelect(id){
    return axios({
        method:'GET',
        url:'/system-ya/menu/key/'+id,
    })
}

export function getcheckUnHandleEvent(){
    return axios({
        method:'GET',
        url:'/system-ya/seat/event/check',
    })
}

export function getloadEventNew(){
    return axios({
        method:'POST',
        url: "/system-ya/seat/eventNewOne/1/lately",
    })
}

export function getLogout(){
    return axios({
        method:'GET',
        url:'/system-ya/logout',
    })
}

export function comparisonDeadline(){
    return axios({
        method:'POST',
        url:'/system-ya/projectProject/comparisonDeadline',
    })
}